import ProductTable from "../../components/Table/Product/ProductTable";
import { ItemProps, useItems } from "../../hooks/useFetch";
import Table from "../../layouts/Table";
import React, { useMemo, useRef, useState } from "react";
import { IProduct } from "../../types";

const AllProduct = () => {
  const [page, setPage] = useState<number>(1);

  const item = useRef([]);
  const ops = useMemo<Partial<ItemProps>>(() => {
    return { type: "product", all: true, page };
  }, [page]);

  const [products, length, loading] = useItems<IProduct>(item.current, ops);
  return (
    <Table
      title="Products"
      icon="fas fa-user"
      theme={"light"}
      total={length}
      onPageChange={(page) => setPage(page)}
      iconColor="text-orange-500"
      loading={loading}
    >
      <ProductTable data={products}></ProductTable>
    </Table>
  );
};

export default AllProduct;
